import { render, staticRenderFns } from "./RistampaEtichette.vue?vue&type=template&id=68b36b3b&scoped=true&"
import script from "./RistampaEtichette.vue?vue&type=script&lang=js&"
export * from "./RistampaEtichette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b36b3b",
  null
  
)

export default component.exports